import ComponentManager from '@/Management/ComponentManager';
import WindowViewModel from '@/ViewModels/Controls/WindowViewModel';
import DropDownListViewModel from '@/ViewModels/Controls/DropDownListViewModel';
import {IWindowViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import UserSpecificDataHelper from '@/Utility/UserSpecificDataHelper';

type ActivityFeedEntryAmountItem = {
    label: string;
    value: number;
}

interface IActivityFeedOptionsWindowViewModelParams extends IWindowViewModelConstructorParameter {

}

export default class ActivityFeedOptionsWindowViewModel extends WindowViewModel {
    public entryAmount: KnockoutComputed<number>;
    public entryAmountLabel: LabelViewModel;
    public entryAmountDropdown: DropDownListViewModel;

    constructor(params: IActivityFeedOptionsWindowViewModelParams) {
        super(params);

        this.entryAmount = UserSpecificDataHelper.loadUserSpecificData<number>('activityFeedOption_entryAmount', 10);
        this.entryAmountLabel = this.createEntryAmountLabel();
        this.entryAmountDropdown = this.createEntryAmountDropDown(this.entryAmount);
    }

    private createEntryAmountLabel(): LabelViewModel {
        return new LabelViewModelBuilder()
            .withErgName('ACTIVITY_FEED.OPTIONS.ENTRY_AMOUNT')
            .build();
    }

    private createEntryAmountDropDown(entryAmount: KnockoutComputed<number>): DropDownListViewModel {
        const items: ActivityFeedEntryAmountItem[] = [
            { label: '5', value: 5 },
            { label: '10', value: 10 },
            { label: '25', value: 25 },
            { label: '50', value: 50 },
        ];
        return new DropDownListViewModel({
            data: items,
            value: entryAmount,
            dataTextField: 'label',
            dataValueField: 'value',
			locator: 'activityfeedoptions.dropdown'
        });
    }
}

ComponentManager.setViewModel('ActivityFeedOptionsWindow', ActivityFeedOptionsWindowViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');